#import "~/graphql/fragments/Assets/DefaultImageAsset.graphql"
#import "~/graphql/fragments/Components/ContentBlocks.graphql"
#import "~/graphql/fragments/Entry/DefaultHero.graphql"
#import "~/graphql/fragments/Entry/HomeHero.graphql"
#import "~/graphql/fragments/Entry/Cards/DetailCard.graphql"

fragment Detail on detail_Entry {
    title

    contentBlocks {
        ... ContentBlocks
    }

    # Footer Flags
    newsletterSignupVisible
    ctaCardsVisible

    # Relations
    neighbourhoodRelation {
        title
        slug
    }

    theme {
        slug
    }

    ... DetailCard
}
